import {padNum, texture} from "p3";
import definitions from "../../../definitions";
import EnemyFlyingInsect from "./EnemyFlyingInsect";

export default class EnemyFirefly extends EnemyFlyingInsect {
    constructor() {
        super(definitions.ENEMY_ID.FIREFLY);

        this.moveSpeed = 1000;
    }

    init() {
        super.init();

        let frames = [];
        for (let i = 0; i < 2; ++i) {
            frames[i] = texture("firefly_" + padNum(i, 2));
        }
        const sequence = new P3.MovieClipSequence(frames, "idle");

        this.addViewWithMovieClip(sequence, "idle");

        this._view.y = -30;

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.2, new PIXI.Point());
    }

    onViewAdded() {
        super.onViewAdded();

        this._view.animationSpeed = 15;
    }
}